// extracted by mini-css-extract-plugin
module.exports = {"columnText":"voucher-list_columnText__M3rYb"};